import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, throwError } from 'rxjs';
import { tap, share, catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

interface LoginResponse {
  success: boolean;
  token?: string;
  user?: any;
}

interface AuthenticatedResponse {
  success: boolean;
  user: any;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private BASE_URL: string = environment.baseURL;
  private TOKEN_KEY: string = 'token';
  user: any;

  loggedin$ = new BehaviorSubject(null);

  constructor(private http: HttpClient) {}

  private saveToken(token) {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  getToken() {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  removeToken() {
    return localStorage.removeItem(this.TOKEN_KEY);
  }

  login(email, password) {
    return this.http
      .post<LoginResponse>(`${this.BASE_URL}/api/v1/auth/login`, {
        email,
        password,
      })
      .pipe(
        tap(({ token, user }) => {
          this.saveToken(token);
          this.user = user;
          this.loggedin$.next(true);
        }),
        share()
      );
  }

  authenticated() {
    return this.http
      .get<AuthenticatedResponse>(`${this.BASE_URL}/api/v1/auth/authenticated`)
      .pipe(
        tap(({ user }) => {
          this.user = user;
          this.loggedin$.next(true);
        }),
        catchError((err) => {
          this.loggedin$.next(false);
          return throwError(err);
        })
      );
  }
}
